import * as React from "react";
import PropTypes from "prop-types";
import { Box, Checkbox, FormControlLabel, FormGroup } from "@mui/material";

export default class CustomCheckbox extends React.Component {
  render() {
    const { label, checkboxitems, fontSize, onChangeFunc } = this.props;

    return (
      <>
        <Box autoComplete="off" mb={2}>
          <FormGroup>
            {checkboxitems.map((item) => (
              <FormControlLabel
                control={<Checkbox checked={item.isChecked} onChange={(e) => onChangeFunc(e, item)} />}
                label={item.value}
              />
            ))}
          </FormGroup>
        </Box>
      </>
    );
  }
}

CustomCheckbox.propTypes = {
  label: PropTypes.string,
  checkboxitems: PropTypes.array,
  fontSize: PropTypes.number,
  func: PropTypes.func,
};
